module.exports = __webpack_public_path__ + "static/img/6272_phase_function_Paper_Points.7af2d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6272_phase_function_Paper_Points.png
// module id = 2+Mm
// module chunks = 0